module.exports = __webpack_public_path__ + "img/20460db5f6af3b3da86da572f3b7a4a.782f50b2.png";